import React from 'react';
import { OverlayWrapper } from './styled.overlay';
import { IOverlay } from '../../../@types/overlay';
import { RequireOnlyTwoOptional } from '../../../@types/genericTypes';

export function Overlay ({
  handleDisplayOverlay,
  canCloseModal = true,
}: RequireOnlyTwoOptional<IOverlay, 'handleDisplayOverlay', 'canCloseModal'>) {
  return (
    <>
      {canCloseModal && handleDisplayOverlay ? (
        <OverlayWrapper onClick={handleDisplayOverlay} />
      ) : (
        <OverlayWrapper />
      )}
    </>
  );
}
